import { FC, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FetchDocumentResponseType } from "src/components/documentUpload/types";
import TableHeader from "src/components/tableHeader";
import { ColumnSortProps } from "src/components/tableHeader/types";

import { DOCUMENT_LISTING_HEADER } from "src/constants/cases";
// import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
import { downloadFileAccordingToExtension } from "src/helpers/downloadFile";
import { sortTableColumns } from "src/helpers/stats";
import useFetch from "src/hooks/useFetch";
import { PatientDocuments } from "src/pages/updatePatient/types";
import { APIEndpoints } from "src/types/apiTypes";




const DocumentListing: FC<{ documents: PatientDocuments[]; }> = ({ documents }): JSX.Element => {
  const [fileName, changeFileName] = useState<string>("");
  const [docListing, updateDocListing] = useState<PatientDocuments[]>([]);
  const [sortingConfig, setSortingConfig] = useState<ColumnSortProps>({
    sort_by: '',
    direction: 'desc',
  });

  const { setLoader, hideLoader } = useContext(LoaderContext)

  useEffect(() => {
    if (documents.length > 0) {
      updateDocListing(documents)
      setSortingConfig({direction:"desc",sort_by:""})
    }
  }, [documents])




  const { data: fetchDocumentData, error: fetchDocumentError, mutate: fetchDocument } =
    useFetch<FetchDocumentResponseType>(APIEndpoints.FETCH_DOCUMENT, {}, {}, false);

  useEffect(() => {
    if (fetchDocumentData || fetchDocumentError) {
      hideLoader();
      if (fetchDocumentData) {
        const { data } = fetchDocumentData;
        downloadFileAccordingToExtension(data, fileName);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDocumentData]);

  const showFetchedFile = (blob_id: number, fileName: string, caseId: number) => {
    setLoader();
    changeFileName(fileName);
    fetchDocument({}, {}, { blob_id, case_id: caseId, type: "fetch" });
  };


  const changeIdOrder = (value: string) => {
    sortTableColumns(value, sortingConfig, setSortingConfig, docListing, updateDocListing)
  };

  return (
    <div className="card my-3">
      <div className="card-header bg-success-subtle">
        <h4 className="mb-0 text-black fs-4">Documents</h4>
      </div>

      <div className="card-body p-0 overflow-auto" style={{ maxHeight: 400 }}>
        {typeof documents === "string" ? (
          <div className="card-body">
            <p className="h3 mb-0 fw-bold">{documents}</p>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped mb-0">
              <thead>
                <tr className="text-start align-items-center">
                  {DOCUMENT_LISTING_HEADER.map((header, index) => (
                    <TableHeader
                      key={index}
                      classNames="align-middle fw-semibold fs-6"
                      tableHeader={{
                        ...header,
                        width: header.label.toLowerCase().includes("name") ? "40%" : ""
                      }}
                      sortConfig={sortingConfig}
                      changeIdOrder={changeIdOrder}
                    />
                  ))}
                </tr>
              </thead>
              <tbody>
                {docListing.map((doc) => (
                  <tr className="align-middle text-start">
                    <td>
                      <Link
                        to={`/cases/${doc.case_id}`}
                        className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text"
                      >
                        {doc.case_id}
                      </Link>
                    </td>
                    <td>{doc.category}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text"
                        onClick={() => showFetchedFile(doc.blob_id || 0, doc.filename, doc.case_id || 0)}
                      >
                        {doc.filename}
                      </button>
                    </td>
                    <td>{doc.size_in_kb}{' '}KB</td>
                    <td>{doc.created_at}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default DocumentListing
